export default function NosotrosPage() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Página de Nosotros</h1>
      <p>Aquí irá la información completa sobre la clínica.</p>
    </div>
  );
}